// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Sfmd","select":"styles_select__FW2l1"};